import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import * as T from './loyaltyRewardsTypes';
import * as A from './loyaltyRewardsActions';
import * as rewardApi from '../../../services/rewardCatalogApi';

function* fetchRewardsSaga(action: ReturnType<typeof A.fetchRewardsRequest>) {
  try {
    const response: Awaited<ReturnType<typeof rewardApi.listRewards>> = yield call(
      rewardApi.listRewards,
      action.payload,
    );
    yield put(A.fetchRewardsSuccess(response.data.rewards));
  } catch (e: any) {
    yield put(A.fetchRewardsFailure(e.message || 'Failed to fetch rewards'));
  }
}

function* fetchRewardDetailSaga(action: ReturnType<typeof A.fetchRewardDetailRequest>) {
  try {
    const response: Awaited<ReturnType<typeof rewardApi.getRewardDetail>> = yield call(
      rewardApi.getRewardDetail,
      action.payload,
    );
    yield put(A.fetchRewardDetailSuccess(response.data));
  } catch (e: any) {
    yield put(A.fetchRewardDetailFailure(e.message || 'Failed to fetch reward detail'));
  }
}

function* updateRewardSaga(action: ReturnType<typeof A.updateRewardRequest>) {
  try {
    const { rewardId, data } = action.payload;
    const response: Awaited<ReturnType<typeof rewardApi.updateReward>> = yield call(
      rewardApi.updateReward,
      rewardId,
      data,
    );
    yield put(A.updateRewardSuccess(rewardId, response.data));
  } catch (e: any) {
    yield put(A.updateRewardFailure(e.message || 'Failed to update reward'));
  }
}

export default function* loyaltyRewardsSaga() {
  yield takeLatest(T.FETCH_REWARDS_REQUEST, fetchRewardsSaga);
  yield takeLatest(T.FETCH_REWARD_DETAIL_REQUEST, fetchRewardDetailSaga);
  yield takeEvery(T.UPDATE_REWARD_REQUEST, updateRewardSaga);
}
